<template>
    <div>
        <div  v-if="arrayAlumnos && arrayAlumnos.length">
            <div class="card p-3" style="position: sticky; top: 0px; z-index: 999;">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex">
                        <h5 class="mb-0 mr-1">ALUMNOS</h5>
                        <md-chip v-if="users && users.alumnos && users.alumnos[0]" class="mini-chip col-blue mb-1" ><strong>{{users.alumnos.length}} <small> ALUMNOS</small></strong></md-chip>
                    </div>
                    <div>
                        <vs-button
                        :loading="loadingGuardar"
                        class="ml-auto"
                        success
                        flat
                        @click="postGuardarObservaciones()"
                    >
                        Guardar cambios
                    </vs-button>
                    </div>
                </div>
            </div>
            <hr>
            <div class="buscadorObs justify-content-end align-items-center mt-3">
                <div class="inputWidth">
                    <vs-input v-model="search" placeholder="Buscar">
                        <template #icon>
                            <i class="fas fa-search"></i>
                        </template>
                    </vs-input>
                </div>
                <div class="d-flex widthPagPer">
                    <div :key="forceMax" class="center mr-2 con-pagination">
                        <vs-pagination only-arrows v-model="page" :length="$vs.getLength(users.alumnos, max)">
                        <vs-select v-model="page" class="p-0">
                            <vs-option
                                v-for="(numberPage,n) in pages"
                                :label="numberPage"
                                :value="numberPage"
                                :key=n>
                                {{ numberPage }}
                            </vs-option>
                        </vs-select>
                        </vs-pagination>
                    </div>
                    <vs-select label="Alumnos por página" v-model="maxPage" :key="maxId" class="p-0">
                        <vs-option v-for="(opts, op) in perPage" :key="op" :label="opts.text" :value="opts.id">
                            {{opts.text}}
                        </vs-option>
                    </vs-select>
                </div>
            </div>
            <vs-row>
                <vs-col v-for="(alumno, a) in $vs.getPage($vs.getSearch(users.alumnos, search), page, max)" :key="a" sm="12" lg="6" class="p-2">
                    <div class="card p-3 my-2">
                        <vs-row>
                            <vs-col sm="12" lg="8">
                                <div class="d-flex">
                                    <vs-avatar size="50" circle>
                                        <img style="object-fit: cover;" :src="alumno.alumno_avatar" @error="setAltImg" alt="">
                                    </vs-avatar>
                                    <div class="ml-3">
                                        <md-chip class="mini-chip col-green mb-1" ><strong>No. lista: {{alumno.no_lista}}</strong></md-chip>
                                        <p class="mb-0"><strong>{{alumno.alumno_name}}</strong></p>
                                    </div>
                                </div>
                            </vs-col>
                            <vs-col sm="12" lg="4">
                                <p class="mb-0"><small>MATRÍCULA: </small><strong>{{alumno.alumno_matricula}}</strong></p>
                                <p class="mb-0"><small>GRUPO ADMINISTRATIVO: </small><strong>{{alumno.grupo_administrativo}}</strong></p>
                            </vs-col>
                        </vs-row>
                        <hr>
                        <p v-if="!campo_formativo_name.length" class="text-center"><small><strong>CARGANDO INFORMACIÓN, POR FAVOR ESPERE</strong></small></p>
                        <div class="d-flex tabsOpciones mb-4" style="overflow: auto" :key="forceRender">
                            <div :class="tabsSelects[a] == ob.campo_formativo ? 'tabSelect' : 'tabNotSelect'" class="d-flex align-items-center text-center" v-for="(ob, w) in campo_formativo_name" :key="w" @click="changeTab(w, a)">
                                <p class="mb-0"><strong>{{ob.campo_formativo}}</strong></p>
                            </div>
                        </div>
                        <div v-for="(ob, o) in obser.filter(e => campos_ids.includes(e.campos_formativos[0].campo_formativo_id))" :key="'o' + o">
                            <vs-row v-if="tabsSelects[a] == ob.campo_formativo"  :key="forceCheck">
                                <vs-col sm="12" lg="12" >
                                    <p><strong>{{ob.campo_formativo}}</strong></p>
                                    <div>
                                    <div class="checkboxes">
                                        <div class="checkboxes__row" v-for="(observa, x) in ob.campos_formativos" :key="x">
                                            <div class="checkboxes__item">
                                            <label class="checkbox style-c">
                                                <input type="checkbox" :value="observa.id" v-model="obs[getId(alumno.registro_academico_id)].campos_formativos[o].observaciones_ids" @change="isDisabled()" :disabled="disabledObs[getId(alumno.registro_academico_id)].observaciones_id[o].observaciones[x].disabled">
                                                <div class="checkbox__checkmark"></div>
                                                <div class="checkbox__body">{{observa.text}}</div>
                                            </label>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </vs-col>
                            </vs-row>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </div>
    </div>
</template>

<script>
import evaluaciones from '../../../api/requests/docente/evaluaciones'
export default {
    props:{
        users: {
            type: Object,
            default: {}
        },
        obser: {
            type: Array,
            default: []
        },
        arrayAlumnos:  {
            type: Array,
            default: []
        },
    },
    data(){
        return{
            obs: [],
            disabledObs: [],
            tabsSelects: [],
            forceRender: 0,
            page:1,
            max: 8,
            forceMax: 0,
            forceCheck: 0,
            maxId: (new Date()).getTime(),
            pages: 0,
            search: '',
            maxPage: '8',
            perPage: [
                {
                    id: "6",
                    text: "6"
                },
                {
                    id: "8",
                    text: "8"
                },
                {
                    id: "14",
                    text: "14"
                },
                {
                    id: "20",
                    text: "20"
                },
                {
                    id: "all",
                    text: "Ver todo"
                }
            ],
            campo_formativo_name: [],
            campos_ids: [],
            loadingGuardar: false
        }
    },
    methods:{
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
        getId(id){
            const x = this.obs.findIndex(alumno => {
                return alumno.registro_academico_id == id
            })
            return x
        },
        maxPagination(){
            const total = this.arrayAlumnos.length
            const max = this.max
            this.pages = Math.ceil(total/max) || 0
            this.forceMax +=1
        },
        getMaxPage(){
            if(this.maxPage == 'all'){
                this.page = 1
                this.max = this.arrayAlumnos.length
            }else{
                this.page = 1
                this.max = this.maxPage
            }
            this.maxPagination()
        },
        isDisabled(){
            const vm = this
            this.obs.forEach((o, index) => {
                o.campos_formativos.forEach((cf, i) => {
                    const check = vm.disabledObs[index].observaciones_id[i].observaciones
                    if(cf.observaciones_ids.length >= 4){
                        check.forEach(d => {
                            if(!cf.observaciones_ids.includes(d.id)){
                                d.disabled = true
                            }else{
                                d.disabled = false
                            }
                        })
                    }else{
                        check.forEach(d => {
                            d.disabled = false
                        })
                    }
                })
            })
        },
        getObservaciones(){
            if((this.users && this.users.alumnos && this.users.alumnos[0]) && this.obser.length){
                this.obs = []
                this.disabledObs = []
                let result = []
                const vm = this
                const info = this.users.alumnos
                const observaciones = this.obser
                info.forEach(i => {
                    let arr = {
                        registro_academico_id: i.registro_academico_id,
                        observaciones_id: []
                    }
                    let arrat = {
                        "registro_academico_id": i.registro_academico_id,
                        "campos_formativos": []
                    }
                    let obsAlumno = []
                    this.campos_ids = i.campos_formativos
                    .map( c => c.campo_formativo_id )
                    .filter( c => c != 5 )
                    const campo_sort = i.campos_formativos.sort( (a, b) => a.campo_formativo_id - b.campo_formativo_id )
                    campo_sort.forEach(ic => {
                        if(ic.campo_formativo_id != 5){
                            arrat.campos_formativos.push(ic)
                            obsAlumno.push(ic.observaciones_ids)
                            // arr.observaciones_id.push({campo_formativo: ic.campo_formativo, observaciones: []}) ya comentada
                            const cf = observaciones.filter(obs => obs.campos_formativos[0].campo_formativo_id ==  ic.campo_formativo_id)
                            let cf_o = {campo_formativo: ic.campo_formativo, observaciones: []}
                            cf[0].campos_formativos.forEach(io => {
                                cf_o.observaciones.push({
                                    id: io.id,
                                    disabled: false
                                })
                            })
                            arr.observaciones_id.push(cf_o)
                        }
                    })
                    // observaciones.forEach((o, index) => {
                    //     let arrayObj = {
                    //         "campo_formativo_id": i.campos_formativos[index].campo_formativo_id,
                    //         "campo_formativo": i.campos_formativos[index].campo_formativo,
                    //         "observaciones_ids": i.campos_formativos[index].observaciones_ids
                    //     }
                    //     arrat.campos_formativos.push(arrayObj)
                    //     obsAlumno.push(i.campos_formativos[index].observaciones_ids)
                    //     arr.observaciones_id.push({campo_formativo: o.campo_formativo, observaciones: []})
                    //     o.campos_formativos.forEach(io => {
                    //         arr.observaciones_id[index].observaciones.push({
                    //             id: io.id,
                    //             disabled: false
                    //         })
                    //     })
                    // })
                    vm.disabledObs.push(arr)
                    result.push(arrat)
                })
                    this.obs = result
                    this.campo_formativo_name = result[0].campos_formativos
                    this.isDisabled()
                    this.tabsObservaciones()
            }
        },
        tabsObservaciones(){
            if(this.users && this.users.alumnos && this.users.alumnos[0]){
                const tab = []
                this.users.alumnos.forEach(u => {
                    const tab_name = this.obs[0].campos_formativos[0].campo_formativo
                    tab.push(tab_name)
                })
                this.tabsSelects = tab
            }
        },
        changeTab(campo, alumno){
            this.tabsSelects[alumno] = this.obser[campo].campo_formativo
            this.forceRender +=1
        },
        async postGuardarObservaciones(){
            this.loadingGuardar = true
            try{
                const params = {
                    ciclo_escolar_id: this.users.params_calificacion.configuracion_evaluacion.ciclo_escolar_id,
                    configuracion_evaluacion_id: this.users.params_calificacion.configuracion_evaluacion.id,
                    institucion_id: this.users.params_calificacion.configuracion_evaluacion.institucion_id,
                    alumnos: this.obs
                }
                const response = await evaluaciones.postGuardarObservaciones(params)
                this.$vs.notification({
                    color: 'success',
                    title: 'Operación éxitosa',
                    duration: 10000,
                    progress: 'auto',
                    text: 'Se han guardado las observaciones satisfactoriamente.'
                })
                this.loadingGuardar = false
                this.$emit("refreshInfo")
            }catch(error){
                console.error(error)
                this.$vs.notification({
                    color: 'danger',
                    title: 'Hubo un error',
                    duration: 10000,
                    progress: 'auto',
                    text: 'Favor de contactar al administrador.'
                })
            }
            

        },
    },
    watch:{
        users() {
            this.maxPagination()
            this.getObservaciones()
        },
        obser() {
            this.getObservaciones()
        },
        maxPage(){
            this.getMaxPage()
        },
        page(){
            this.forceCheck +=1
        }
    }
}
</script>

<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, #fff8ec); 
    @include text-colors ('blue', #37aefb, #cfecfe); 
    @include text-colors ('purple', #6F3E90, #E8DAEF); 

}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}

.tabsOpciones{
    overflow: auto;
    font-size: 11px;
}

.tabSelect{
    background: #2471A3;
    color: white;
    padding: 0.5em 1em;
    border-radius: 10px;
    cursor: pointer;
}
.tabNotSelect{
    background: #F8F9F9;
    color: #7B7D7D;
    padding: 0.5em 1em;
    cursor: pointer;
}

@mixin small {
  @media only screen and (min-width: 600px) {
    @content;
  }
}

@mixin medium {
  @media only screen and (min-width: 1024px) {
    @content;
  }
}

@mixin large {
  @media only screen and (min-width: 1440px) {
    @content;
  }
}

.buscadorObs{
    @include small {
        display: flex;
    }
}
.widthPagPer{
    width: 100%;
    @include small {
        width: 50%;
    }
    @include medium {
        width: 20%;
    }
    @include large {
        width: 15%;
    }
}
.inputWidth{
    width: 100%;
    @include small {
        width: 100%;
    }
    @include medium {
        width: 25%;
    }
    @include large {
        width: 20%;
    }
}
</style>

<style scoped>
.checkboxes {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.checkboxes__row {
  display: flex;
}
.checkboxes__row:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.checkboxes__item {
  padding: 15px;
  width: 100%;
}

/* STYLE C */

.checkbox.style-c {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox.style-c input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox.style-c input:checked ~ .checkbox__checkmark {
  background-color: #46C93A;
  border:none;
}
.checkbox.style-c input:checked ~ .checkbox__checkmark:after {
  opacity: 1;
}
.checkbox.style-c:hover input ~ .checkbox__checkmark {
  background-color: #F9FAFA;
}
.checkbox.style-c:hover input:checked ~ .checkbox__checkmark {
  background-color: #46C93A;
  border:none;
}
.checkbox.style-c input:disabled ~ .checkbox__checkmark {
  background-color: #dfdfdf;
}
.checkbox.style-c .checkbox__checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #F9FAFA;
  border:1px solid #B3B6B7;
  transition: background-color 0.25s ease;
  border-radius: 4px;
}
.checkbox.style-c .checkbox__checkmark:after {
  content: "";
  position: absolute;
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.25s ease;
}
.checkbox.style-c .checkbox__body {
  color: #333;
  line-height: 1.4;
  font-size: 16px;
}
</style>

